import { Stack } from '@mui/material';
import React, { useCallback } from 'react';
import TextView from '../../TextView';
import CloseIcon from '@mui/icons-material/Close';

function DowngradeHeader({ downgradeType = 0, onClose = () => { } }) {
    const getTitleDetails = useCallback(() => {
        switch (downgradeType) {
            case 1:
                return { label: 'Essential', color: '#325AE9', initial: 'E' };
            case 2:
                return { label: 'Premium', color: '#A15FFF', initial: 'P' };
            default:
                return { label: 'Free', color: '#98A2B3', initial: 'F' };
        }
    }, [downgradeType]);

    const description = useCallback(() => {
        switch (downgradeType) {
            case 1:
                return 'Essential accounts are limited to 500MB of storage. Please select the Wheels that will fit within this storage limit. All unselected Wheels will be disabled and deleted after 90 days, unless reactivated before then.';
            case 2:
                return 'Premium accounts are limited to 2GB of storage. Please select the Wheels that will fit within this storage limit. All unselected Wheels will be disabled and deleted after 90 days, unless reactivated before then.';
            default:
                return `Free Accounts are limited to 5 Wheels, 5 Clones, and 250MB of storage. Everything else will be held in your Gallery's 'Downgrade Locker' for 90 days, after which they will be erased.`;
        }
    }, [downgradeType]);

    const { label, color, initial } = getTitleDetails();

    return (
        <Stack >

            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                <Stack direction="row" justifyContent="flex-start" alignItems="center">
                    <TextView
                        style={{
                            fontSize: '20px',
                            lineHeight: '25px',
                            fontWeight: '600',
                            color: '#0F0F0F',
                        }}
                    >
                        So, you've chosen to Downgrade to
                    </TextView>
                    <Stack
                        style={{
                            height: '25px',
                            width: '25px',
                            backgroundColor: color,
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginLeft: '5px',

                        }}
                    >
                        <TextView
                            style={{
                                fontSize: '20px',
                                lineHeight: '25px',
                                fontWeight: '600',
                                color: 'white',
                            }}
                        >
                            {initial}
                        </TextView>
                    </Stack>
                    <TextView
                        style={{
                            fontSize: '20px',
                            lineHeight: '24px',
                            fontWeight: '600',
                            color: '#0F0F0F',
                            marginLeft: '5px',
                        }}
                    >
                        {label}
                    </TextView>
                </Stack>
                <CloseIcon onClick={onClose} style={{ cursor: 'pointer' }} />

            </Stack>
            <TextView style={{
                fontSize: '14px',
                lineHeight: '20px',
                fontWeight: '400',
                color: '#565556',
                textAlign: 'left'
            }}>{description()}</TextView>

            {downgradeType === 0 && <Stack my={1.5} style={{ backgroundColor: 'rgba(251, 229, 202, 0.5)', borderRadius: '8px', padding: '12px' }}>
                <TextView style={{
                    fontSize: '12px',
                    lineHeight: '20px',
                    fontWeight: '400',
                    color: '#0F0F0F',
                    textAlign: 'left'
                }}>ℹ️  Any Wheels and Clones that exceed the free-tier limit of 5 will be permanently disabled unless you upgrade to a paid subscription. Even if you delete one of your active Wheels, previously disabled content will remain inaccessible until you upgrade.</TextView>
            </Stack>}
        </Stack>
    );
}

export default React.memo(DowngradeHeader);